import styled, { css } from 'styled-components';
import { getFixedSpace, mq } from '../../../stylesheets/tools';

const StyledModalHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: ${getFixedSpace('xs')};
  width: 100%;
  display: flex;
  z-index: 999;

  button:not(.modalHeader__language-switch) {
    margin-right: ${getFixedSpace('s')};
  }

  .modalHeader__language-switch {
    a {
      font-size: 28px;
    }
  }

  button:first-of-type {
    flex-grow: 2;
    display: flex;
    align-items: flex-start;
    margin-left: 0;

    ${mq('m')} {
      display: inline-block;
    }
  }

  ${mq('m')} {
    width: auto;
    display: inline-block;
  }

  ${mq('xl')} {
    padding: ${getFixedSpace('xs')} ${getFixedSpace('m')};
  }

  .modalHeader__accessibility-button,
  .modalHeader__search-button {
    svg,
    g,
    path {
      ${mq('m', 'max')} {
        ${props =>
          props.currentLevel > 2 &&
          css`
            fill: #000;
          `}
      }
    }
  }

  .modalHeader__language-switch {
    ${mq('m', 'max')} {
      ${props =>
        props.currentLevel > 2 &&
        css`
          span {
            color: #000;
          }

          &:hover span {
            background: #000;
            color: #fff;
          }

          svg,
          path,
          g {
            fill: #000;
          }
        `}
    }
  }
`;

export default StyledModalHeader;
